
'use client';

import { useAuthUser } from '@/lib/auth/common/useSession';

interface HeroSectionProps {
    heroText1?: string;
    heroText2?: string;
    heroText3?: string;
    /** Server-resolved login state from cookie; avoids flash of wrong background on load */
    initialIsLoggedIn?: boolean;
}

export function HeroSection({ heroText1 = 'Unlock Your', heroText2 = 'Contentstack Potential', heroText3 = 'Build and ship digital experiences faster', initialIsLoggedIn = false }: HeroSectionProps) {
    // initialIsLoggedIn seeds the first paint; useAuthUser takes over once resolved and stays reactive.
    const { isLoggedIn: authLoggedIn, isLoading: authLoading } = useAuthUser();
    const isLoggedIn = authLoading ? initialIsLoggedIn : authLoggedIn;

    return (
        <section className="overflow-x-clip overflow-y-visible py-0">
            <div className="mx-auto w-full relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-[3.5fr_2fr] lg:items-stretch">

                    <div className="section flex flex-col gap-2 lg:mb-16 my-16 py-0">
                        <h1 className="hero-text text-text-default-strong">
                            {heroText1} <br /> {heroText2}
                        </h1>
                        <p className="cs-s-body-light tab:cs-l-body text-text-default-strong">
                            {heroText3 || ''}
                        </p>
                    </div>

                    {/* Right side: height matches left content dynamically */}
                    <div className="relative -mr-4 tab:-mr-8 lg:-mr-[72px] min-h-0">
                        <div className="relative pt-8 lg:pt-0 h-full min-h-[300px] hidden lg:block w-full">
                            {isLoggedIn ? (
                                <>
                                    <div className="absolute inset-0 lg:left-1/6 lg:right-0 pointer-events-none z-0 hero-gradient-bg-desktop"></div>
                                    <div className="absolute bottom-0 lg:left-0 right-0 h-[412px] w-[273px] rotate-[90deg] pointer-events-none hero-gradient-layer-desktop"></div>
                                </>
                            ) : (
                                <>
                                    <div className="absolute inset-0 left-1/3 tab:left-1/8 lg:left-0 lg:right-0 pointer-events-none z-0 hero-gradient-bg-desktop"></div>
                                    <div className="absolute bottom-0 pointer-events-none hero-gradient-layer-desktop h-[149px] w-full rotate-[180deg] -right-20 lg:rotate-[180deg] lg:-right-20"></div>
                                </>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}


